import styles from './DotsSpinner.module.css';

export const DotSpinner = ({
  className,
  style,
  color,
}: {
  className?: string;
  style?: React.CSSProperties;
  color?: string;
}) => {
  const isValidColor = (color: string | undefined) => {
    if (!color) return false;
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    const rgbaRegex =
      /^rgba?\(\s*(\d{1,3}\s*,\s*){2,3}\d{1,3}\s*(,\s*(0|1|0?\.\d+))?\)$/;
    return hexRegex.test(color) || rgbaRegex.test(color);
  };

  const safeColor = isValidColor(color) ? color : 'black';

  return (
    <span
      className={className ? `${styles.root} ${className}` : styles.root}
      style={style}
    >
      <i style={{ animationDelay: '0', color: safeColor }}>•</i>
      <i style={{ animationDelay: '0.05s', color: safeColor }}>•</i>
      <i style={{ animationDelay: '0.1s', color: safeColor }}>•</i>
    </span>
  );
};
